(function () {
    "use strict";

    // ═══════════════════════════════════════════════════════════════
    // CONFIGURATION
    // ═══════════════════════════════════════════════════════════════

    // Local storage key for storing user's zip code
    const STORAGE_KEY = "local_delivery_eligible_zip";

    // Read vendor config (populated by Liquid before this script loads)
    const CONFIG = window.LOCAL_DELIVERY_CONFIG || {};
    const VENDORS = CONFIG.vendors || {};

    // Neutral pages that should not trigger any modal or redirect
    const NEUTRAL_PATHS = [
        "/search",
        "/pages/about-us",
        "/pages/halal-certification",
        "/pages/terms-and-conditions",
        "/pages/privacy-policy",
        "/pages/contact",
        "/pages/faq",
        "/cart",
    ];

    // CSS ID for the modal (prevent duplicates)
    const MODAL_ID = "local-delivery-modal-v2";

    // ─── Header config for local pages ───
    // Menu items to HIDE completely on local pages (lowercase, must match data-menu-label)
    const HEADER_HIDE_LABELS = ["catering","seafood market", "ramadan", "eid essentials", "qurbani/udhiya"];

    // Menu items whose links should point to /pages/nyc on local pages
    const HEADER_HOME_LABELS = ["home"];

    // Menu items whose links should point to /pages/nyc on local pages
    const LOCAL_GROCERY = ["grocery"];


    // Menu items whose links should point to /pages/nyc on local pages
    const LOCAL_RESTAURANTS = ["restaurants"];

    // Menu items whose links should point to /pages/nyc on local pages
    const LOCAL_Meal = ["meal-plans"];



    // ═══════════════════════════════════════════════════════════════
    // STORAGE FUNCTIONS
    // ═══════════════════════════════════════════════════════════════

    function getStoredZip() {
        return localStorage.getItem(STORAGE_KEY);
    }

    function setStoredZip(zip) {
        localStorage.setItem(STORAGE_KEY, zip);

        // Dispatch event for cart validation
        document.dispatchEvent(
            new CustomEvent("localdelivery:zipchanged", {
                detail: { zip: zip },
            }),
        );
        // console.log("[LocalDelivery v2] ZIP changed event dispatched:", zip);
    }

    function clearStoredZip() {
        localStorage.removeItem(STORAGE_KEY);
    }

    function isValidZip(zip) {
        return /^\d{5}$/.test(zip);
    }

    // ═══════════════════════════════════════════════════════════════
    // ELIGIBILITY FUNCTIONS
    // ═══════════════════════════════════════════════════════════════

    /**
     * Check if a zip is eligible for a specific vendor
     */
    function isEligibleForVendor(vendorHandle, zip) {
        if (!zip || !isValidZip(zip)) return false;
        var vendor = VENDORS[vendorHandle];
        if (!vendor || !vendor.eligibleZips) return false;
        return vendor.eligibleZips.includes(zip.trim());
    }

    /**
     * Get list of vendor handles eligible for a given zip
     */
    function getEligibleVendors(zip) {
        if (!zip || !isValidZip(zip)) return [];
        return Object.keys(VENDORS).filter(function (handle) {
            return isEligibleForVendor(handle, zip);
        });
    }

    /**
     * Check if zip is eligible for at least one vendor
     */
    function isEligibleForAny(zip) {
        return getEligibleVendors(zip).length > 0;
    }

    /**
     * Get vendor info by handle
     */
    function getVendorByHandle(handle) {
        return VENDORS[handle] || null;
    }

    /**
        * General eligibility check (for any vendor)
     */
    function isEligible(zip) {
        return isEligibleForAny(zip);
    }

    // ═══════════════════════════════════════════════════════════════
    // PAGE DETECTION
    // ═══════════════════════════════════════════════════════════════

    /**
     * Determine what type of page we're on
     * @returns {'local-landing'|'local-collection'|'local-product'|'neutral'|'global'}
     */
    function getPageType() {
        var pathname = window.location.pathname;

        if (
            pathname === "/pages/nyc" ||
            pathname === "/pages/nyc/" ||
            pathname === "/pages/local-test" ||
            pathname === "/pages/local-test/" ||
            pathname === "/pages/local-restaurants" ||
            pathname === "/pages/local-restaurants/" ||
            pathname === "/pages/local-grocery" ||
            pathname === "/pages/local-grocery/" ||
            pathname === "/pages/meal-plan-nyc" ||
            pathname === "/pages/meal-plan-nyc/" ||
            pathname === "/pages/neerab-7-8-meal-plan-nyc" ||
            pathname === "/pages/neerab-7-8-meal-plan-nyc/"
        ) {
            return "local-landing";
        }


        if (pathname.includes("/collections/") && pathname.includes("/local")) {
            return "local-collection";
        }

        if (document.querySelector('[data-is-local-product="true"]')) {
            return "local-product";
        }

        for (var i = 0; i < NEUTRAL_PATHS.length; i++) {
            if (pathname.includes(NEUTRAL_PATHS[i])) {
                return "neutral";
            }
        }

        return "global";
    }

    /**
     * Extract vendor collection handle from URL
     */
    function getVendorFromURL() {
        var match = window.location.pathname.match(
            /\/collections\/([^\/]+)\/local/,
        );
        return match ? match[1] : null;
    }

    /**
     * Get vendor handles associated with current product page
     * Reads from data-vendor-handles attribute set by Liquid
     */
    function getProductVendorHandles() {
        var el = document.querySelector("[data-vendor-handles]");
        if (!el || !el.dataset.vendorHandles) return [];
        return el.dataset.vendorHandles
            .split(",")
            .map(function (h) {
                return h.trim();
            })
            .filter(Boolean);
    }

    // ═══════════════════════════════════════════════════════════════
    // HEADER ADJUSTMENT FOR LOCAL PAGES
    // ═══════════════════════════════════════════════════════════════

    /**
     * Adjust the header navigation when on local pages.
     *
     * On local pages:
     *   - Logo link → /pages/nyc
     *   - "Home" menu item → /pages/nyc (instead of /)
     *   - "Catering" (and any items in HEADER_HIDE_LABELS) → hidden
     *   - Restaurants, Grocery, FAQ, etc. → visible and functional
     *
     * On global/neutral pages:
     *   - No changes (function returns immediately)
     *
     * REQUIRES: data-menu-label="{{ link.title | downcase | strip }}" on
     * each <li> in both the desktop nav and mobile drawer.
     *
     * @param {string} pageType - Result of getPageType()
     */
    function adjustHeaderForLocalPages(pageType) {
        // Only modify header on local pages
        // Also modify for neutral pages IF user has a valid stored ZIP
        if (
            pageType !== "local-landing" &&
            pageType !== "local-collection" &&
            pageType !== "local-product"
        ) {
            // Check if neutral page with stored ZIP - treat as local
            if (pageType === "neutral") {
                var storedZip = getStoredZip();
                if (!storedZip || !isValidZip(storedZip)) {
                    return; // No valid ZIP, don't modify header
                } else {
                    pageType = "local-landing"; // Has valid ZIP, continue to modify header
                }
                // Has valid ZIP, continue to modify header
            } else {
                return;
            }
        }

        // 1. Change logo link to /pages/nyc
        var logoLink = document.querySelector(".header__heading-link");
        if (logoLink) {
            logoLink.href = "/pages/nyc";
        }

        // 2. Process DESKTOP menu items
        var desktopItems = document.querySelectorAll(
            ".list-menu--inline > .list-menu__item[data-menu-label]",
        );
        desktopItems.forEach(function (item) {
            var label = item.getAttribute("data-menu-label");
            // console.log("[LocalDelivery v2] Processing header item:", label);
            if (!label) return;

            // Hide items in the hide list (e.g., "catering")
            if (HEADER_HIDE_LABELS.includes(label)) {
                item.style.display = "none";
                item.setAttribute("aria-hidden", "true");
                item.tabIndex = -1;
            }

            // Redirect home-type items to /pages/nyc
            if (HEADER_HOME_LABELS.includes(label)) {
                var link =
                    item.querySelector("a.header__menu-item") ||
                    item.querySelector("a");
                if (link) link.href = "/pages/nyc";
            }

            if (LOCAL_GROCERY.includes(label)) {
                // var link =
                //     item.querySelector("a.header__menu-item") ||
                //     item.querySelector("a");
                // if (link) link.href = "/pages/local-grocery";
                item.innerHTML = `<a href="/pages/local-grocery" class="header__menu-item link link--text focus-inset">
                    Grocery
                </a>`;
            }

            if (LOCAL_RESTAURANTS.includes(label)) {
                    // var link =
                    //     item.querySelector("a.header__menu-item") ||
                    //     item.querySelector("a");
                    // if (link) link.href = "/pages/local-restaurants";
                item.innerHTML = `<a href="/pages/local-restaurants" class="header__menu-item link link--text focus-inset">
                    Restaurants
                </a>`;
            }

            if (LOCAL_Meal.includes(label)) {
                item.innerHTML = `<a href="/pages/meal-plan-nyc" class="header__menu-item link link--text focus-inset">
                    Meal Plans
                </a>`;
            }
        });

        // 3. Process MOBILE drawer menu items
        var drawerItems = document.querySelectorAll(
            ".menu-drawer__menu > li[data-menu-label]",
        );
        drawerItems.forEach(function (item) {
            var label = item.getAttribute("data-menu-label");
            if (!label) return;

            // Hide items in the hide list
            if (HEADER_HIDE_LABELS.includes(label)) {
                item.style.display = "none";
                item.setAttribute("aria-hidden", "true");
                item.tabIndex = -1;
            }

            // Redirect home-type items to /pages/nyc
            if (HEADER_HOME_LABELS.includes(label)) {
                var link =
                    item.querySelector("a.menu-drawer__menu-item") ||
                    item.querySelector("a");
                if (link) link.href = "/pages/nyc";
            }

            if (LOCAL_GROCERY.includes(label)) {
                // var link =
                //     item.querySelector("a.menu-drawer__menu-item") ||
                //     item.querySelector("a");
                // if (link) link.href = "/pages/local-grocery";
                item.innerHTML = `<a href="/pages/local-grocery" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">
                    Grocery
                </a>`;
            }

            if (LOCAL_RESTAURANTS.includes(label)) {
                // var link =
                //     item.querySelector("a.menu-drawer__menu-item") ||
                //     item.querySelector("a");
                // if (link) link.href = "/pages/local-restaurants";
                item.innerHTML = `<a href="/pages/local-restaurants" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">
                    Restaurants
                </a>`;
            }

            if (LOCAL_Meal.includes(label)) {
                item.innerHTML = `<a href="/pages/meal-plan-nyc" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">
                    Meal Plans
                </a>`;
            }
        });

        // 4. Hide collection submenu bar (hover dropdowns) on local pages
        // var submenuBar = document.querySelector(".collection-submenu-bar");
        // if (submenuBar) {
        //     submenuBar.style.display = "none";
        // }

        // 5. Hide desktop dropdown submenus for Restaurants and Grocery
        // var dropdownMenus = document.querySelectorAll(
        //     ".header__submenu.global-settings-popup",
        // );
        // dropdownMenus.forEach(function (menu) {
        //     menu.style.display = "none";
        // });


    }

    // ═══════════════════════════════════════════════════════════════
    // UI: VENDOR GRID FILTERING
    // ═══════════════════════════════════════════════════════════════

    /**
     * Filter all vendor grids on the page.
     * Hides vendor cards where user's zip is not eligible.
     */
    function filterVendorGrids() {
        var grids = document.querySelectorAll("[data-local-delivery-grid]");
        if (grids.length === 0) return;

        var zip = getStoredZip();
        var eligibleList = getEligibleVendors(zip);

        // console.log(
        //     "[LocalDelivery v2] Filtering grids. ZIP:",
        //     zip,
        //     "Eligible vendors:",
        //     eligibleList,
        // );

        grids.forEach(function (grid) {
            var items = grid.querySelectorAll("[data-vendor-handle]");
            var visibleCount = 0;

            items.forEach(function (item) {
                var handle = item.dataset.vendorHandle;
                if (eligibleList.includes(handle)) {
                    item.style.display = "";
                    item.classList.remove("vendor-not-eligible");
                    visibleCount++;
                } else {
                    item.style.display = "none";
                    item.classList.add("vendor-not-eligible");
                }
            });

            // Remove the loading/checking state
            grid.classList.remove("checking-eligibility");

            // Handle empty state message
            var container =
                grid.closest(".collection-grid-container") ||
                grid.closest(".page-width") ||
                grid.closest(".collection-list-wrapper") ||
                grid.parentElement;
            var emptyState = container
                ? container.querySelector(".no-eligible-vendors")
                : null;
            if (emptyState) {
                emptyState.style.display =
                    visibleCount === 0 ? "block" : "none";
            }
        });

        // Update the "change zip" bar if present
        updateZipBar();
    }

    /**
     * Update the zip display bar on landing page
     */
    function updateZipBar() {
        var bar = document.querySelector("[data-zip-bar]");
        if (!bar) return;

        var zip = getStoredZip();
        var wrapper = document.getElementById("header-zip-bar-wrapper");
        if (zip && isValidZip(zip)) {
            bar.style.display = "flex";
            if (wrapper) wrapper.style.display = "block";
            var zipDisplay = bar.querySelector("[data-current-zip]");
            if (zipDisplay) zipDisplay.textContent = zip;

            var countDisplay = bar.querySelector("[data-vendor-count]");
            if (countDisplay) {
                var count = getEligibleVendors(zip).length;
                countDisplay.textContent =
                    count + " vendor" + (count !== 1 ? "s" : "");
            }
        } else {
            bar.style.display = "none";
            if (wrapper) wrapper.style.display = "none";
        }
    }

    // ═══════════════════════════════════════════════════════════════
    // UI: ZIP CODE MODAL
    // ═══════════════════════════════════════════════════════════════

    var modalStylesInjected = false;
    function injectModalStyles() {
        if (modalStylesInjected) return;
        modalStylesInjected = true;

        var style = document.createElement("style");
        style.id = "ld-modal-styles-v2";
        style.textContent =
            ".ld-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:99999;padding:20px;opacity:0;transition:opacity 0.3s ease}" +
            ".ld-modal-overlay.visible{opacity:1}" +
            ".ld-modal-content{background:#fff;border-radius:20px;max-width:440px;width:100%;padding:36px 32px;position:relative;box-shadow:0 25px 60px rgba(0,0,0,0.3);transform:translateY(20px);transition:transform 0.3s ease}" +
            ".ld-modal-overlay.visible .ld-modal-content{transform:translateY(0)}" +
            ".ld-modal-close{position:absolute;top:16px;right:20px;background:none;border:none;font-size:28px;cursor:pointer;color:#999;line-height:1;padding:4px 8px;transition:color 0.2s}" +
            ".ld-modal-close:hover{color:#333}" +
            ".ld-modal-header{text-align:center;margin-bottom:24px}" +
            ".ld-modal-header h2{margin:0 0 8px;font-size:22px;font-weight:700;color:#1a1a1a;line-height:1.3}" +
            ".ld-modal-header p{margin:0;color:#666;font-size:15px;line-height:1.5}" +
            ".ld-input-group{display:flex;gap:12px;margin-bottom:16px}" +
            ".ld-zip-input{flex:1;padding:14px 16px;border:2px solid #e0e0e0;border-radius:12px;font-size:16px;outline:none;transition:border-color 0.2s}" +
            ".ld-zip-input:focus{border-color:#F15A25}" +
            ".ld-btn-primary{padding:14px 24px;background:#F15A25;color:#fff;border:none;border-radius:12px;font-size:16px;font-weight:600;cursor:pointer;transition:background 0.2s;white-space:nowrap}" +
            ".ld-btn-primary:hover{background:#d94d1a}" +
            ".ld-btn-secondary{width:100%;padding:14px;background:#f5f5f5;color:#333;border:none;border-radius:12px;font-size:15px;font-weight:500;cursor:pointer;margin-top:12px;transition:background 0.2s}" +
            ".ld-btn-secondary:hover{background:#e8e8e8}" +
            ".ld-result{padding:14px 16px;border-radius:12px;text-align:center;font-size:15px;font-weight:500;display:none;margin-bottom:8px}" +
            ".ld-result.show{display:block}" +
            ".ld-result.success{background:#e8f5e9;color:#2e7d32}" +
            ".ld-result.error{background:#ffebee;color:#c62828}";

        document.head.appendChild(style);
    }

    /**
     * Show the zip code modal
     */
    function showZipModal(options) {
        options = options || {};
        var title = options.title || "Local Delivery";
        var subtitle =
            options.subtitle ||
            "Enter your ZIP code to check delivery availability.";
        var vendorHandle = options.vendorHandle || null;
        var onSuccess = options.onSuccess || function () {};
        var onCancel = options.onCancel || function () {};
        var prefillZip =
            options.prefillZip !== undefined ? options.prefillZip : true;

        // Prevent multiple modals
        if (document.getElementById(MODAL_ID)) return;
        
        if (vendorHandle == null) {
            filterVendorGrids();
        }

        injectModalStyles();

        var storedZip = getStoredZip();
        var prefillValue = prefillZip && storedZip ? storedZip : "";

        var modal = document.createElement("div");
        modal.id = MODAL_ID;
        modal.innerHTML =
            '<div class="ld-modal-overlay">' +
            '  <div class="ld-modal-content">' +
            '    <button class="ld-modal-close" aria-label="Close">&times;</button>' +
            '    <div class="ld-modal-header">' +
            "      <h2>" +
            escapeHtml(title) +
            "</h2>" +
            "      <p>" +
            escapeHtml(subtitle) +
            "</p>" +
            "    </div>" +
            '    <div class="ld-modal-body">' +
            '      <div class="ld-input-group">' +
            '        <input type="text" class="ld-zip-input" id="ld-zip-input"' +
            '          placeholder="Enter 5-digit ZIP" maxlength="5"' +
            '          pattern="[0-9]*" inputmode="numeric"' +
            '          value="' +
            prefillValue +
            '"' +
            "        >" +
            '        <button class="ld-btn-primary" id="ld-check-btn">Check</button>' +
            "      </div>" +
            '      <div class="ld-result" id="ld-result"></div>' +
            "    </div>" +
            '    <div class="ld-modal-footer">' +
            '      <button class="ld-btn-secondary" id="ld-back-btn" style="display:none;">' +
            "        \u2190 Back to Nationwide Delivery" +
            "      </button>" +
            "    </div>" +
            "  </div>" +
            "</div>";

        document.body.appendChild(modal);

        // Animate in
        requestAnimationFrame(function () {
            var overlay = modal.querySelector(".ld-modal-overlay");
            if (overlay) overlay.classList.add("visible");
        });

        var zipInput = document.getElementById("ld-zip-input");
        var checkBtn = document.getElementById("ld-check-btn");
        var resultDiv = document.getElementById("ld-result");
        var backBtn = document.getElementById("ld-back-btn");
        var closeBtn = modal.querySelector(".ld-modal-close");

        function checkZip() {
            // console.log(vendorHandle, "Checking Vendor Handle...");
            var zip = zipInput.value.trim();

            if (!isValidZip(zip)) {
                showResult("Please enter a valid 5-digit ZIP code.", "error");
                return;
            }

            if (vendorHandle) {
                // ── Checking for a SPECIFIC vendor ──
                if (isEligibleForVendor(vendorHandle, zip)) {
                    setStoredZip(zip);
                    showResult("\u2713 You're eligible! Loading...", "success");
                    setTimeout(function () {
                        closeModal();
                        onSuccess(zip);
                    }, 800);
                } else {
                    var vendor = getVendorByHandle(vendorHandle);
                    var vendorName = vendor ? vendor.name : "This vendor";
                    showResult(
                        "\u2717 " +
                            vendorName +
                            " doesn't deliver to ZIP " +
                            zip +
                            ".",
                        "error",
                    );
                    backBtn.style.display = "block";

                    // Check if ANY other vendor delivers here
                    var othersEligible = getEligibleVendors(zip).filter(
                        function (h) {
                            return h !== vendorHandle;
                        },
                    );
                    if (othersEligible.length > 0) {
                        setStoredZip(zip);
                        var otherNames = othersEligible
                            .map(function (h) {
                                var v = getVendorByHandle(h);
                                return v ? v.name : h;
                            })
                            .join(", ");
                        resultDiv.innerHTML +=
                            '<div style="margin-top:10px;font-size:13px;color:#555;">' +
                            "But " +
                            escapeHtml(otherNames) +
                            " deliver" +
                            (othersEligible.length === 1 ? "s" : "") +
                            " to your area!" +
                            "</div>";
                    }
                }
            } else {
                // ── Checking for ANY vendor (landing page) ──
                var eligible = getEligibleVendors(zip);

                if (eligible.length > 0) {
                    setStoredZip(zip);
                    showResult(
                        "\u2713 " +
                            (eligible.length > 1 ? "Some" : "") +
                            " vendor" +
                            (eligible.length > 1 ? "s" : "") +
                            " deliver to your area!",
                        "success",
                        "",
                    );
                    updateZipBar();
                    setTimeout(function () {
                        closeModal();
                        onSuccess(zip);
                    }, 800);
                } else {
                    showResult(
                        "\u2717 No vendors deliver to your area yet.",
                        "error",
                    );
                    backBtn.style.display = "block";
                    clearStoredZip();
                }
            }
        }

        function showResult(message, type) {
            resultDiv.textContent = message;
            resultDiv.className = "ld-result show " + type;
        }

        checkBtn.addEventListener("click", checkZip);
        zipInput.addEventListener("keypress", function (e) {
            if (e.key === "Enter") checkZip();
        });
        zipInput.addEventListener("focus", function () {
            resultDiv.className = "ld-result";
            backBtn.style.display = "none";
        });
        closeBtn.addEventListener("click", function () {
            closeModal();
            onCancel();
        });
        backBtn.addEventListener("click", function () {
            window.location.href = "/";
        });

        setTimeout(function () {
            zipInput.focus();
        }, 150);
    }

    /**
     * Close and remove the modal
     */
    function closeModal() {
        var modal = document.getElementById(MODAL_ID);
        if (!modal) return;

        var overlay = modal.querySelector(".ld-modal-overlay");
        if (overlay) overlay.classList.remove("visible");

        setTimeout(function () {
            modal.remove();
        }, 300);
    }

    // ═══════════════════════════════════════════════════════════════
    // PAGE HANDLERS
    // ═══════════════════════════════════════════════════════════════

    /**
     * Handle the local landing page (/pages/nyc)
     */
    function handleLandingPage() {
        var zip = getStoredZip();

        if (!zip || !isValidZip(zip)) {
            showZipModal({
                title: "New York Local Delivery",
                subtitle:
                    "Enter your ZIP code to see which restaurants and stores deliver to you.",
                vendorHandle: null,
                onSuccess: function () {
                    filterVendorGrids();
                },
                onCancel: function () {
                    window.location.href = "/";
                },
            });
        } else if (!isEligibleForAny(zip)) {
            showZipModal({
                title: "Update Your Location",
                subtitle:
                    "ZIP " +
                    zip +
                    " doesn't match any current delivery zones. Please try again.",
                vendorHandle: null,
                prefillZip: true,
                onSuccess: function () {
                    filterVendorGrids();
                },
                onCancel: function () {
                    window.location.href = "/";
                },
            });
        } else {
            filterVendorGrids();
        }
    }

    /**
     * Handle a local collection page (/collections/{handle}/local)
     */
    function handleCollectionPage() {
        var vendorHandle = getVendorFromURL();
        var zip = getStoredZip();

        // console.log(
        //     "[LocalDelivery v2] Collection page. Vendor:",
        //     vendorHandle,
        //     "ZIP:",
        //     zip,
        // );

        if (!vendorHandle) {
            // console.warn("[LocalDelivery v2] Could not detect vendor from URL");
            return;
        }

        var vendor = getVendorByHandle(vendorHandle);
        var vendorName = vendor ? vendor.name : vendorHandle;

        if (!zip || !isValidZip(zip)) {
            showZipModal({
                title: "Check Delivery Availability",
                subtitle:
                    "Enter your ZIP code to check if " +
                    vendorName +
                    " delivers to you.",
                vendorHandle: vendorHandle,
                onSuccess: function () {
                    window.location.reload();
                },
                onCancel: function () {
                    window.location.href = "/pages/nyc";
                },
            });
        } else if (!isEligibleForVendor(vendorHandle, zip)) {
            showZipModal({
                title: "Not Available in Your Area",
                subtitle:
                    vendorName +
                    " doesn't deliver to ZIP " +
                    zip +
                    ". Try a different ZIP or browse other vendors.",
                vendorHandle: vendorHandle,
                prefillZip: true,
                onSuccess: function () {
                    window.location.reload();
                },
                onCancel: function () {
                    window.location.href = "/pages/nyc";
                },
            });
        }
    }

    /**
     * Handle a local product page
     */
    function handleProductPage() {
        var vendorHandles = getProductVendorHandles();
        var zip = getStoredZip();
        
        // Also check for vendor handle from data attribute on product container
        var productContainer = document.querySelector('[data-local-vendor-handle]');
        if (productContainer && productContainer.dataset.localVendorHandle) {
            var containerHandle = productContainer.dataset.localVendorHandle;
            if (!vendorHandles.includes(containerHandle)) {
                vendorHandles.push(containerHandle);
            }
        }

        // console.log(
        //     "[LocalDelivery v2] Product page. Vendors:",
        //     vendorHandles,
        //     "ZIP:",
        //     zip,
        // );

        if (vendorHandles.length === 0) {
            // console.warn(
            //     "[LocalDelivery v2] No vendor handles found for this product",
            // );
            return;
        }
        
        // If vendor not in config, try falling back to 'green' (Grocery)
        var hasConfiguredVendor = vendorHandles.some(function(h) {
            return getVendorByHandle(h) !== null;
        });
        
        if (!hasConfiguredVendor && !vendorHandles.includes('green')) {
            // console.log("[LocalDelivery v2] No configured vendor found, falling back to 'green'");
            vendorHandles.push('green');
        }

        if (!zip || !isValidZip(zip)) {
            showZipModal({
                title: "Check Delivery Availability",
                subtitle:
                    "Enter your ZIP code to verify local delivery eligibility.",
                vendorHandle: vendorHandles[0],
                onSuccess: function () {
                    window.location.reload();
                },
                onCancel: function () {
                    window.location.href = "/pages/nyc";
                },
            });
            return;
        }

        var eligibleForProduct = vendorHandles.some(function (handle) {
            return isEligibleForVendor(handle, zip);
        });

        if (!eligibleForProduct) {
            showZipModal({
                title: "Not Available in Your Area",
                subtitle:
                    "This product is not available for local delivery to ZIP " +
                    zip +
                    ".",
                vendorHandle: vendorHandles[0],
                prefillZip: true,
                onSuccess: function () {
                    window.location.reload();
                },
                onCancel: function () {
                    window.location.href = "/pages/nyc";
                },
            });
        }
    }

    // ═══════════════════════════════════════════════════════════════
    // UTILITY
    // ═══════════════════════════════════════════════════════════════

    function escapeHtml(str) {
        var div = document.createElement("div");
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    // ═══════════════════════════════════════════════════════════════
    // INITIALIZATION
    // ═══════════════════════════════════════════════════════════════

    function initialize() {
        var pageType = getPageType();
        // console.log(
        //     "[LocalDelivery v2] Page type:",
        //     pageType,
        //     "| Stored ZIP:",
        //     getStoredZip(),
        // );

        // ── STEP 1: Adjust header for local pages ──
        // Always runs first, regardless of zip status.
        // If user is on ANY local page, header updates immediately.
        adjustHeaderForLocalPages(pageType);

        // Show ZIP bar on any local-related page when ZIP is stored
        var storedZip = getStoredZip();
        if (storedZip && isValidZip(storedZip)) {
            if (
                pageType === "local-landing" ||
                pageType === "local-collection" ||
                pageType === "local-product" ||
                pageType === "neutral"
            ) {
                updateZipBar();
            }
        }

        // ── STEP 2: Handle page-specific logic ──
        switch (pageType) {
            case "local-landing":
                handleLandingPage();
                break;

            case "local-collection":
                handleCollectionPage();
                break;

            case "local-product":
                handleProductPage();
                break;

            case "neutral":
                // console.log("[LocalDelivery v2] Neutral page — no action");
                break;

            case "global":
                // console.log("[LocalDelivery v2] Global page — no action");
                clearStoredZip();
                break;
        }
    }

    // Run when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initialize);
    } else {
        initialize();
    }

    // ═══════════════════════════════════════════════════════════════
    // GLOBAL API
    // ═══════════════════════════════════════════════════════════════

    window.LocalDeliveryGuard = {
        // Storage
        getStoredZip: getStoredZip,
        setStoredZip: setStoredZip,
        clearStoredZip: clearStoredZip,

        // Eligibility
        isEligible: isEligible,
        isEligibleForVendor: isEligibleForVendor,
        getEligibleVendors: getEligibleVendors,
        isEligibleForAny: isEligibleForAny,
        getVendorByHandle: getVendorByHandle,

        // Page detection
        getPageType: getPageType,
        getVendorFromURL: getVendorFromURL,
        isLocalPage: function () {
            var pt = getPageType();
            return (
                pt === "local-landing" ||
                pt === "local-collection" ||
                pt === "local-product"
            );
        },

        // UI
        filterVendorGrids: filterVendorGrids,
        showZipModal: showZipModal,
        closeModal: closeModal,
        adjustHeaderForLocalPages: adjustHeaderForLocalPages,

        // Config reference
        VENDORS: VENDORS,
        debug: function () {
            // console.log("Local-Delivery-Guard VENDORS:", VENDORS);
            // console.log("Local-Delivery-Guard Stored ZIP:", getStoredZip());
            // console.log("Local-Delivery-Guard Page type:", getPageType());
        },
    };
})();
